<template>
  <v-app :style="{ background: themeStyles.background, color: themeStyles.color }">

    <!-- AUTH HEADER -->
    <!-- <v-system-bar
      height="32"
      :style="{
        background: themeStyles.surface,
        color: themeStyles.color
      }"
      class="px-3 d-flex align-center justify-end"
    >
     
    </v-system-bar> -->
     <AuthHeader />

    <!-- MAIN AUTH CONTENT -->
    <v-main >
      <router-view />
    </v-main>

    <!-- FOOTER -->
    <v-footer
      height="40"
      :style="{
        background: themeStyles.surface,
        color: themeStyles.color
      }"
      class="d-flex align-center justify-center"
    >
      <span class="text-caption opacity-70">Secure authentication</span>
    </v-footer>

  </v-app>
</template>

<script setup>
import { useThemeStore } from "@/store/auth"
import AuthHeader from "../components/AuthHeader.vue"

const themeStore = useThemeStore()
const themeStyles = themeStore.themeStyles
</script>